import React from 'react';
import useMedia from 'use-media';
import MessageConst from '../../../const/RTCC/messageConst';
import "../../../resources/RTCC/css/common/radio_box_style.css";
import { Label } from '../../atoms/RTCC/label';
import { BirthDateForm } from '../../molecules/RTCC/birthDateForm';
import { LabelInputForm } from '../../molecules/RTCC/labelInputForm';
import { RadioButtonForm } from '../../molecules/RTCC/radioButtonForm';
import './../../../resources/RTCC/css/userInput/userInput.css';

export const RoomInputList = (props) => {
    const { state,
        flgList,
        onChange,
        handleGuestInfo,
        handleGuestGenderInfo,
        handleGuestBirthdayInfo,
        handleRepresentInfo,
        handleRepresentGenderInfo,
        handleRepresentBirthdayInfo,
        handleRepresentFlg,
        responsiveFlg } = props;

    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });

    const represent =
        <div className="representInputWrapper">
            <div className="userInput2">
                <div className={"stayInfo"} style={styles.userInput}>
                    <Label
                        label={"代表者情報"}
                        className="representInfoLabel"
                    />
                    <LabelInputForm
                        label={"氏名（漢字）"}
                        type={"id"}
                        id="representName"
                        placeholder="山田一郎"
                        className={flgList.representNameError ? "inputKeywordError" : "inputKeyword"}
                        value={props.representInfo ? props.representInfo.representName : ""}
                        onChange={() => handleRepresentInfo("representName")}
                        labelClassName="popupLabel"
                        wrapClassName="userInputTextWrap3"
                    />
                    <LabelInputForm
                        label={"氏名（カナ）"}
                        type={"id"}
                        id="representNameKana"
                        placeholder="ヤマダイチロウ"
                        className={flgList.representNameKanaError ? "inputKeywordError" : "inputKeyword"}
                        value={props.representInfo ? props.representInfo.representNameKana : ""}
                        onChange={() => handleRepresentInfo("representNameKana")}
                        labelClassName="popupLabel"
                        wrapClassName="userInputTextWrap3"
                    />
                    <LabelInputForm
                        label={"姓（パスポート表記）"}
                        type={"id"}
                        id="representLastNamePassport"
                        placeholder="YAMADA"
                        className={flgList.representLastNamePassportError ? "inputKeywordError" : "inputKeyword"}
                        value={props.representInfo ? props.representInfo.representLastNamePassport : ""}
                        onChange={() => handleRepresentInfo("representLastNamePassport")}
                        labelClassName="popupLabel"
                        wrapClassName="userInputTextWrap3"
                    />
                    <LabelInputForm
                        label={"名（パスポート表記）"}
                        type={"id"}
                        id="representFirstNamePassport"
                        placeholder="ICHIRO"
                        className={flgList.representFirstNamePassportError ? "inputKeywordError" : "inputKeyword"}
                        value={props.representInfo ? props.representInfo.representFirstNamePassport : ""}
                        onChange={() => handleRepresentInfo("representFirstNamePassport")}
                        labelClassName="popupLabel"
                        wrapClassName="userInputTextWrap3"
                    />
                    {/* <div style={responsiveFlg ? {display: "block"} : {display: "flex"}}> */}
                    <RadioButtonForm
                        data={props.gender.map(value => ({
                            checked: value.value == props.representInfo.representGenderId,
                            text: value.text,
                            value: value.value
                        }))}
                        style={{display: "flex"}}
                        name="representSex"
                        id="representSex"
                        label={"性別"}
                        titleClassName="popupLabel"
                        inputClassName="onlyPlanRadio"
                        labelClassName="genderTypeLabel"
                        wrapClassName="guestGenderPullDownWrap"
                        onChange={handleRepresentGenderInfo}
                    />
                    {/* </div> */}
                    <div className="birthDateArea" style={isWideTablet ? styles.birthDateAreaStyle_media : styles.birthDateAreaStyle}>
                        <Label label={"生年月日"} className="popupLabel" />
                        <div style={{ display: "flex" }}>
                            <BirthDateForm
                                wrapClassName="datePullDownWrap"
                                labelClassName="popupLabel"
                                className={flgList.representBirthday ? "userInput_datePullDownButtonError" : "userInput_datePullDownButton"}
                                birthDateClassName={isWideTablet ? "userInputBirthDateInnerWrap_media" : "userInputBirthDateInnerWrap"}
                                yearId="representYear"
                                monthId="representMonth"
                                dayId="representDay"
                                birthDateLabel="userBirthDateLabel"
                                yearTitle="年"
                                monthTitle="月"
                                dayTitle="日"
                                yearNum={props.representInfo ? props.representInfo.representBirthday.split("-")[0] : "0000"}
                                monthNum={props.representInfo ? props.representInfo.representBirthday.split("-")[1] : "00"}
                                dayNum={props.representInfo ? props.representInfo.representBirthday.split("-")[2] : "00"}
                                firstYear={1900}
                                pullDownAreaStyle={responsiveFlg ? styles.birthDatePullDownAreaSp : styles.pullDownArea}
                                handleGuestInfo={handleRepresentBirthdayInfo}
                            />
                        </div>
                    </div>
                    <div className="telNumArea">
                        <LabelInputForm
                            label={"郵便番号"}
                            type={"id"}
                            id="postCode"
                            placeholder="115-0045"
                            className={flgList.postCodeError ? "inputKeywordError" : "inputKeyword"}
                            value={props.representInfo ? props.representInfo.postCode : ""}
                            onChange={() => handleRepresentInfo("postCode")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap2"
                        />
                    </div>
                    <div className="telNumArea">
                        <LabelInputForm
                            label={"住所"}
                            type={"id"}
                            id="address"
                            placeholder="東京都北区赤羽１丁目１－１"
                            className={flgList.addressError ? "inputKeywordError" : "inputKeyword"}
                            value={props.representInfo ? props.representInfo.address : ""}
                            onChange={() => handleRepresentInfo("address")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                        />
                    </div>
                    <div className="telNumArea">
                        <LabelInputForm
                            label={"日中ご連絡の取れる電話番号"}
                            type={"id"}
                            id="telNum"
                            placeholder="012-345-6789"
                            className={flgList.telNumError ? "inputKeywordError" : "inputKeyword"}
                            value={props.representInfo ? props.representInfo.telNum : ""}
                            onChange={() => handleRepresentInfo("telNum")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                        />
                    </div>
                    <div className="mailArea">
                        <LabelInputForm
                            label={"メールアドレス"}
                            type={"id"}
                            id="mail"
                            placeholder="rtcc@trust.jp"
                            className={flgList.mailError ? "inputKeywordError" : "inputKeyword"}
                            value={props.representInfo ? props.representInfo.mail : ""}
                            onChange={() => handleRepresentInfo("mail")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                        />
                    </div>
                    <div className="subMailArea">
                        <LabelInputForm
                            label={"メールアドレス(確認用)"}
                            type={"id"}
                            id="subMail"
                            placeholder="rtcc@trust.jp"
                            className={flgList.subMailError ? "inputKeywordError" : "inputKeyword"}
                            value={props.representInfo ? props.representInfo.subMail : ""}
                            onChange={() => handleRepresentInfo("subMail")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                        />
                    </div>
                </div>
            </div>
        </div>;

    const accampany = (roomIndex, guestIndex, sumGuests, guestInfo) =>
        <div className="userInput2">
            <div className={"stayInfo"} style={styles.userInput}>
                <div style={guestIndex === 0 ? styles.guestTitle : styles.guestTitleTopBorder}>
                    <div className="humanTitleLabel">
                        <Label label={"宿泊者" + sumGuests} className="humanTitleLabel" />
                        <Label
                            label={guestIndex === 0 ? "(部屋代表者)" : guestInfo.ageGroupFlg == "adult" ? "(大人)" : "(こども)"}
                            className="humanTitleLabel"
                        />
                    </div>
                    <div style={guestIndex === 0 ? { display: "block" } : { display: "none" }}>
                        <RadioButtonForm
                            data={[{ value: "represent", checked: guestInfo.representFlg, text: "代表" }]}
                            id={"representFlg" + roomIndex}
                            style={{ display: "flex" }}
                            name="representFlg"
                            titleClassName="inputTitleLabel"
                            inputClassName="onlyPlanRadio"
                            onChange={() => handleRepresentFlg(roomIndex)}
                        />
                    </div>

                    {/* <PullDownOptionForm
                        wrapClassName="guestPullDownWrap"
                        className="humanTypePullDownButton"
                        data={props.humanType}
                        id={"ageGroupId" + roomIndex + "_" + guestIndex}
                        state={guestInfo.ageGroupId}
                        onChange={() => handleGuestInfo("ageGroupId", roomIndex, guestIndex)}
                    /> */}
                </div>
                <LabelInputForm
                    label={"氏名（漢字）"}
                    type={"id"}
                    id={"guestName" + roomIndex + "_" + guestIndex}
                    placeholder="山田次郎"
                    className={flgList.errorRoomList &&
                        flgList.errorRoomList[roomIndex].errorGuestList[guestIndex] &&
                        flgList.errorRoomList[roomIndex].errorGuestList[guestIndex].errorGuestName
                        ? "inputKeywordError" : "inputKeyword"}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap"
                    value={guestInfo.guestName}
                    onChange={() => handleGuestInfo("guestName", roomIndex, guestIndex)}
                />
                <LabelInputForm
                    label={"氏名（カナ）"}
                    type={"id"}
                    id={"guestNameKana" + roomIndex + "_" + guestIndex}
                    placeholder="ヤマダジロウ"
                    className={flgList.errorRoomList &&
                        flgList.errorRoomList[roomIndex].errorGuestList[guestIndex] &&
                        flgList.errorRoomList[roomIndex].errorGuestList[guestIndex].errorGuestNameKana
                        ? "inputKeywordError" : "inputKeyword"}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap2"
                    value={guestInfo.guestNameKana}
                    onChange={() => handleGuestInfo("guestNameKana", roomIndex, guestIndex)}
                />
                <LabelInputForm
                    label={"姓（パスポート表記）"}
                    type={"id"}
                    id={"guestLastNamePassport" + roomIndex + "_" + guestIndex}
                    placeholder="YAMADA"
                    className={flgList.errorRoomList &&
                        flgList.errorRoomList[roomIndex].errorGuestList[guestIndex] &&
                        flgList.errorRoomList[roomIndex].errorGuestList[guestIndex].errorGuestLastNamePassport
                        ? "inputKeywordError" : "inputKeyword"}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap3"
                    value={guestInfo.guestLastNamePassport}
                    onChange={() => handleGuestInfo("guestLastNamePassport", roomIndex, guestIndex)}
                />
                <LabelInputForm
                    label={"名（パスポート表記）"}
                    type={"id"}
                    id={"guestFirstNamePassport" + roomIndex + "_" + guestIndex}
                    placeholder="JIRO"
                    className={flgList.errorRoomList &&
                        flgList.errorRoomList[roomIndex].errorGuestList[guestIndex] &&
                        flgList.errorRoomList[roomIndex].errorGuestList[guestIndex].errorGuestFirstNamePassport
                        ? "inputKeywordError" : "inputKeyword"}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap3"
                    value={guestInfo.guestFirstNamePassport}
                    onChange={() => handleGuestInfo("guestFirstNamePassport", roomIndex, guestIndex)}
                />
                <RadioButtonForm
                    data={props.gender.map(value => ({
                        checked: value.value == guestInfo.guestGenderId,
                        text: value.text,
                        value: value.value
                    }))}
                    style={{ display: "flex" }}
                    name={"guestGenderId" + roomIndex + "_" + guestIndex}
                    id={"guestGenderId" + roomIndex + "_" + guestIndex}
                    label={"性別"}
                    wrapClassName="guestGenderPullDownWrap"
                    titleClassName="popupLabel"
                    inputClassName="onlyPlanRadio"
                    labelClassName="genderTypeLabel"
                    onChange={() => handleGuestGenderInfo(roomIndex, guestIndex)}
                />
                <div className="birthDateArea" style={isWideTablet ? styles.birthDateAreaStyle2_media : styles.birthDateAreaStyle2}>
                    <Label label={"生年月日"} className="popupLabel" />
                    <div style={{ display: "flex" }}>
                        <BirthDateForm
                            wrapClassName="datePullDownWrap"
                            labelClassName="popupLabel"
                            className={flgList.errorRoomList &&
                                flgList.errorRoomList[roomIndex].errorGuestList[guestIndex] &&
                                (flgList.errorRoomList[roomIndex].errorGuestList[guestIndex].errorGuestBirthday ||
                                    flgList.errorRoomList[roomIndex].errorGuestList[guestIndex].errorAdult)
                                ? "userInput_datePullDownButtonError" : "userInput_datePullDownButton"}
                            birthDateClassName={isWideTablet ? "userInputBirthDateInnerWrap_media" : "userInputBirthDateInnerWrap"}
                            yearId={"guestYear" + roomIndex + "_" + guestIndex}
                            monthId={"guestMonth" + roomIndex + "_" + guestIndex}
                            dayId={"guestDay" + roomIndex + "_" + guestIndex}
                            yearNum={guestInfo.guestBirthday.split("-")[0]}
                            monthNum={guestInfo.guestBirthday.split("-")[1]}
                            dayNum={guestInfo.guestBirthday.split("-")[2]}
                            birthDateLabel="userBirthDateLabel"
                            yearTitle="年"
                            monthTitle="月"
                            dayTitle="日"
                            firstYear={1900}
                            pullDownAreaStyle={responsiveFlg ? styles.birthDatePullDownAreaSp : styles.pullDownArea}
                            handleGuestInfo={() => handleGuestBirthdayInfo(roomIndex, guestIndex)}
                        />
                    </div>
                </div>
            </div>
        </div>;

    const getrooms = () => {
        const room = [];
        let sumGuests = 0;
        props.roomList.map((value, roomIndex) => {
            let guest = [];
            value.guestInfo.map((value, guestIndex) => {
                sumGuests += 1;
                guest.push(
                    <div key={"guest" + guestIndex} className="userInputWrapper2">
                        {accampany(roomIndex, guestIndex, sumGuests, value)}
                    </div>);
            });
            room.push(
                <div key={"room" + roomIndex}>
                    <div className="userInputWrapper3">
                        <div><Label label={(roomIndex + 1) + "部屋目"} className="roomIndex" /></div>
                    </div>
                    {guest}
                </div>
            );
        })
        return <>{room}</>;
    }
    const rooms = getrooms();

    return (
        <>
            <div>{represent}</div>
            <div>{rooms}</div>
        </>
    );
}

const styles = {
    firstRoomWrapper: {
        width: "80%",
        margin: "0px auto",
        backgroundColor: "#808080",
        padding: "10px 10% 10px 10%",
    },
    guestTitle: {
        display: "flex",
        padding: "20px 0px 15px 0px",
        alignItems: "center",
        whiteSpace: "nowrap"
    },
    guestTitleTopBorder: {
        display: "flex",
        padding: "40px 0px 15px 0px",
        alignItems: "center",
        whiteSpace: "nowrap",
        borderTop: "1px solid #bfbec5",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    roomNum: {
        display: "flex",
        padding: "20px 0px 20px 0px",
        marginBottom: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #bfbec5",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
        borderTop: "1px solid #bfbec5",
    },
    bottomLink: {
        padding: "3px",
        color: "black",
        fontSize: "small",
    },
    breadCrumb
        : {
        display: "flex",
        color: "white",
        marginBottom: "50px",
    },
    breadCrumb2
        : {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10%",
    },
    genderWrap: {
        marginBottom: "20px",
    },
    gender: {
        display: "flex",
    },
    genderLabel: {
        margin: "0px 30px 0px 10px",
    },
    confirmbox: {
        width: "100%",
        margin: "10px auto",
        display: "flex",
    },
    paymentOption: {
        display: "flex",
        marginTop: "20px",
    },
    fee: {
        display: "flex",
        justifyContent: "space-between",
    },
    pullDownArea: {
        display: "flex",
        alignItems: "center"
    },
    pullDownAreaSp: {
        display: "block",
        alignItems: "center"
    },
    birthDatePullDownAreaSp: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    birthDateAreaStyle: {
        padding: "0px 0px 25px 0px",
    },
    birthDateAreaStyle2: {
        padding: "0px 0px 20px 0px",
    },
    birthDateAreaStyle_media: {
        padding: "0px 0px 5px 0px",
    },
    birthDateAreaStyle2_media: {
        padding: "0px 0px 0px 0px",
    },
}